// Verb dictionaries by difficulty level.
// BASIC: original 34 verbs; questions mix past simple and past participle.
// ADVANCED / EXPERT: 54 verbs from Emma's school study guide, grouped in 10
// phonetic families. The family tag drives the per-wave question pool.

export const VERBS_BASIC = [
  { base: 'go', past: 'went', participle: 'gone', es: 'ir' },
  { base: 'eat', past: 'ate', participle: 'eaten', es: 'comer' },
  { base: 'see', past: 'saw', participle: 'seen', es: 'ver' },
  { base: 'do', past: 'did', participle: 'done', es: 'hacer' },
  { base: 'have', past: 'had', participle: 'had', es: 'tener' },
  { base: 'come', past: 'came', participle: 'come', es: 'venir' },
  { base: 'get', past: 'got', participle: 'gotten', es: 'obtener' },
  { base: 'give', past: 'gave', participle: 'given', es: 'dar' },
  { base: 'take', past: 'took', participle: 'taken', es: 'tomar' },
  { base: 'make', past: 'made', participle: 'made', es: 'hacer/crear' },
  { base: 'say', past: 'said', participle: 'said', es: 'decir' },
  { base: 'know', past: 'knew', participle: 'known', es: 'saber/conocer' },
  { base: 'think', past: 'thought', participle: 'thought', es: 'pensar' },
  { base: 'find', past: 'found', participle: 'found', es: 'encontrar' },
  { base: 'tell', past: 'told', participle: 'told', es: 'contar/decir' },
  { base: 'run', past: 'ran', participle: 'run', es: 'correr' },
  { base: 'write', past: 'wrote', participle: 'written', es: 'escribir' },
  { base: 'read', past: 'read', participle: 'read', es: 'leer' },
  { base: 'speak', past: 'spoke', participle: 'spoken', es: 'hablar' },
  { base: 'sing', past: 'sang', participle: 'sung', es: 'cantar' },
  { base: 'drink', past: 'drank', participle: 'drunk', es: 'beber' },
  { base: 'sleep', past: 'slept', participle: 'slept', es: 'dormir' },
  { base: 'win', past: 'won', participle: 'won', es: 'ganar' },
  { base: 'lose', past: 'lost', participle: 'lost', es: 'perder' },
  { base: 'fly', past: 'flew', participle: 'flown', es: 'volar' },
  { base: 'swim', past: 'swam', participle: 'swum', es: 'nadar' },
  { base: 'break', past: 'broke', participle: 'broken', es: 'romper' },
  { base: 'buy', past: 'bought', participle: 'bought', es: 'comprar' },
  { base: 'bring', past: 'brought', participle: 'brought', es: 'traer' },
  { base: 'catch', past: 'caught', participle: 'caught', es: 'atrapar' },
  { base: 'fall', past: 'fell', participle: 'fallen', es: 'caer' },
  { base: 'feel', past: 'felt', participle: 'felt', es: 'sentir' },
  { base: 'hear', past: 'heard', participle: 'heard', es: 'oir' },
  { base: 'leave', past: 'left', participle: 'left', es: 'irse/dejar' },
];

export const VERBS_ADVANCED = [
  // Familia -O-
  { base: 'write', past: 'wrote', participle: 'written', es: 'escribir', family: '-O-' },
  { base: 'drive', past: 'drove', participle: 'driven', es: 'conducir', family: '-O-' },
  { base: 'ride', past: 'rode', participle: 'ridden', es: 'montar', family: '-O-' },
  { base: 'steal', past: 'stole', participle: 'stolen', es: 'robar', family: '-O-' },
  { base: 'break', past: 'broke', participle: 'broken', es: 'romper', family: '-O-' },
  { base: 'get', past: 'got', participle: 'gotten', es: 'obtener', family: '-O-' },
  { base: 'forget', past: 'forgot', participle: 'forgotten', es: 'olvidar', family: '-O-' },
  { base: 'win', past: 'won', participle: 'won', es: 'ganar', family: '-O-' },
  { base: 'wear', past: 'wore', participle: 'worn', es: 'usar', family: '-O-' },
  { base: 'speak', past: 'spoke', participle: 'spoken', es: 'hablar', family: '-O-' },

  // Familia -A-
  { base: 'begin', past: 'began', participle: 'begun', es: 'empezar', family: '-A-' },
  { base: 'drink', past: 'drank', participle: 'drunk', es: 'beber', family: '-A-' },
  { base: 'swim', past: 'swam', participle: 'swum', es: 'nadar', family: '-A-' },
  { base: 'sing', past: 'sang', participle: 'sung', es: 'cantar', family: '-A-' },
  { base: 'run', past: 'ran', participle: 'run', es: 'correr', family: '-A-' },
  { base: 'sit', past: 'sat', participle: 'sat', es: 'sentarse', family: '-A-' },
  { base: 'give', past: 'gave', participle: 'given', es: 'dar', family: '-A-' },
  { base: 'come', past: 'came', participle: 'come', es: 'venir', family: '-A-' },

  // Familia -T-
  { base: 'send', past: 'sent', participle: 'sent', es: 'enviar', family: '-T-' },
  { base: 'build', past: 'built', participle: 'built', es: 'construir', family: '-T-' },
  { base: 'dream', past: 'dreamt', participle: 'dreamt', es: 'soñar', family: '-T-' },
  { base: 'smell', past: 'smelt', participle: 'smelt', es: 'oler', family: '-T-' },
  { base: 'lose', past: 'lost', participle: 'lost', es: 'perder', family: '-T-' },

  // Familia OLD-
  { base: 'sell', past: 'sold', participle: 'sold', es: 'vender', family: 'OLD-' },
  { base: 'tell', past: 'told', participle: 'told', es: 'contar', family: 'OLD-' },

  // Familia 1E+T
  { base: 'feel', past: 'felt', participle: 'felt', es: 'sentir', family: '1E+T' },
  { base: 'keep', past: 'kept', participle: 'kept', es: 'mantener', family: '1E+T' },
  { base: 'sleep', past: 'slept', participle: 'slept', es: 'dormir', family: '1E+T' },

  // Familia -GHT-
  { base: 'buy', past: 'bought', participle: 'bought', es: 'comprar', family: '-GHT-' },
  { base: 'fight', past: 'fought', participle: 'fought', es: 'pelear', family: '-GHT-' },
  { base: 'think', past: 'thought', participle: 'thought', es: 'pensar', family: '-GHT-' },
  { base: 'teach', past: 'taught', participle: 'taught', es: 'enseñar', family: '-GHT-' },
  { base: 'catch', past: 'caught', participle: 'caught', es: 'atrapar', family: '-GHT-' },

  // Familia -EW-
  { base: 'know', past: 'knew', participle: 'known', es: 'saber', family: '-EW-' },
  { base: 'grow', past: 'grew', participle: 'grown', es: 'crecer', family: '-EW-' },
  { base: 'fly', past: 'flew', participle: 'flown', es: 'volar', family: '-EW-' },
  { base: 'draw', past: 'drew', participle: 'drawn', es: 'dibujar', family: '-EW-' },

  // Familia 1E/10
  { base: 'meet', past: 'met', participle: 'met', es: 'conocer', family: '1E/10' },
  { base: 'choose', past: 'chose', participle: 'chosen', es: 'elegir', family: '1E/10' },

  // Familia -OO-
  { base: 'take', past: 'took', participle: 'taken', es: 'tomar', family: '-OO-' },
  { base: 'understand', past: 'understood', participle: 'understood', es: 'entender', family: '-OO-' },

  // Familia NO CHANGE
  { base: 'read', past: 'read', participle: 'read', es: 'leer', family: 'NO-CHANGE' },
  { base: 'put', past: 'put', participle: 'put', es: 'poner', family: 'NO-CHANGE' },
  { base: 'hurt', past: 'hurt', participle: 'hurt', es: 'lastimar', family: 'NO-CHANGE' },
  { base: 'cost', past: 'cost', participle: 'cost', es: 'costar', family: 'NO-CHANGE' },

  // Familia ORPHANS
  { base: 'be', past: 'was', participle: 'been', es: 'ser/estar', family: 'ORPHANS' },
  { base: 'do', past: 'did', participle: 'done', es: 'hacer', family: 'ORPHANS' },
  { base: 'have', past: 'had', participle: 'had', es: 'tener', family: 'ORPHANS' },
  { base: 'go', past: 'went', participle: 'gone', es: 'ir', family: 'ORPHANS' },
  { base: 'make', past: 'made', participle: 'made', es: 'hacer/crear', family: 'ORPHANS' },
  { base: 'eat', past: 'ate', participle: 'eaten', es: 'comer', family: 'ORPHANS' },
  { base: 'see', past: 'saw', participle: 'seen', es: 'ver', family: 'ORPHANS' },
  { base: 'hear', past: 'heard', participle: 'heard', es: 'oír', family: 'ORPHANS' },
  { base: 'find', past: 'found', participle: 'found', es: 'encontrar', family: 'ORPHANS' },
];

// Back-compat alias so anything still importing { VERBS } keeps working.
export const VERBS = VERBS_BASIC;

// Wave plans for the Advanced level: one new family group per wave.
export const ADVANCED_WAVES = [
  { wave: 1, families: ['-O-'], label: 'FAMILY -O-', description: 'Past tense ends in O' },
  { wave: 2, families: ['-A-'], label: 'FAMILY -A-', description: 'Past tense ends in A' },
  { wave: 3, families: ['-T-', 'OLD-', '1E+T'], label: 'FAMILIES -T- / OLD / 1E+T', description: 'Past tense ends in T' },
  { wave: 4, families: ['-GHT-', '-EW-'], label: 'FAMILIES -GHT- / -EW-', description: 'GHT and EW patterns' },
  { wave: 5, families: ['1E/10', '-OO-', 'NO-CHANGE', 'ORPHANS'], label: 'FINAL CHALLENGE', description: 'Mixed patterns and orphans' },
];

// Wave plans for Expert: cumulative — each wave includes previous families + a new group.
export const EXPERT_WAVES = [
  { wave: 1, families: ['-O-'], label: 'FAMILY -O-', description: 'Past and past participle' },
  { wave: 2, families: ['-O-', '-A-'], label: 'FAMILIES -O- + -A-', description: 'Cumulative challenge' },
  { wave: 3, families: ['-O-', '-A-', '-T-', 'OLD-', '1E+T'], label: 'ADD -T- / OLD / 1E+T', description: 'Cumulative challenge' },
  { wave: 4, families: ['-O-', '-A-', '-T-', 'OLD-', '1E+T', '-GHT-', '-EW-'], label: 'ADD -GHT- / -EW-', description: 'Cumulative challenge' },
  { wave: 5, families: ['-O-', '-A-', '-T-', 'OLD-', '1E+T', '-GHT-', '-EW-', '1E/10', '-OO-', 'NO-CHANGE', 'ORPHANS'], label: 'MASTER WAVE', description: 'All 54 verbs' },
];

export function getVerbsByFamily(families) {
  return VERBS_ADVANCED.filter((v) => families.includes(v.family));
}

export function pickRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function shuffle(arr) {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function generateFakeForm(base) {
  const stem = base.length > 1 ? base.slice(0, -1) : base;
  const fakes = [
    base + 'ed',
    base + 'd',
    stem + 'ed',
    base + 'en',
    base + 'ing',
    base + 't',
    stem + 'en',
    base + 's',
  ];
  return fakes[Math.floor(Math.random() * fakes.length)];
}

function buildDistractors(verb, correct, otherForm) {
  const distractors = new Set();
  let attempts = 0;
  while (distractors.size < 2 && attempts < 40) {
    const fake = generateFakeForm(verb.base);
    if (fake !== correct && fake !== otherForm && fake !== verb.base) {
      distractors.add(fake);
    }
    attempts++;
  }
  while (distractors.size < 2) {
    distractors.add(verb.base + Math.random().toString(36).slice(2, 4));
  }
  return [...distractors];
}

// Resolve which form (past vs participle) the question should ask for.
// askMode: 'past' | 'participle' | 'both' | 'random' (random === both)
function resolveAskParticiple(askMode) {
  if (askMode === 'past') return false;
  if (askMode === 'participle') return true;
  return Math.random() < 0.5;
}

export function generateQuestion(verbPool = VERBS_BASIC, askMode = 'random') {
  // Back-compat: if caller passed a single verb object instead of an array, wrap it.
  let pool = verbPool;
  if (!Array.isArray(pool)) pool = [pool];
  if (!pool.length) pool = VERBS_BASIC;

  const verb = pickRandom(pool);
  const askParticiple = resolveAskParticiple(askMode);
  const correct = askParticiple ? verb.participle : verb.past;
  const otherForm = askParticiple ? verb.past : verb.participle;

  // Half the time include the OTHER form (past vs participle) as a wrong option
  // so the player has to distinguish forms, not just irregular vs regular.
  const useOtherFormAsDistractor = Math.random() < 0.5 && otherForm !== correct;
  let wrongPool;
  if (useOtherFormAsDistractor) {
    const fakes = buildDistractors(verb, correct, otherForm);
    wrongPool = [otherForm, fakes[0]];
  } else {
    wrongPool = buildDistractors(verb, correct, otherForm);
  }
  const options = shuffle([correct, ...wrongPool]);
  return {
    verbBase: verb.base,
    es: verb.es,
    type: askParticiple ? 'participle' : 'past',
    correct,
    options,
    label: askParticiple ? 'PAST PARTICIPLE' : 'PAST SIMPLE',
  };
}

export function regenerateOptions(question, verbPool = VERBS_BASIC, askMode = 'random') {
  let pool = verbPool;
  if (!Array.isArray(pool)) pool = [pool];
  if (!pool.length) pool = VERBS_BASIC;
  const verb = pool.find((v) => v.base === question.verbBase) || VERBS_BASIC.find((v) => v.base === question.verbBase);
  if (!verb) return generateQuestion(pool, askMode);
  return generateQuestion([verb], askMode);
}
